import React, { useEffect, useRef } from "react";
import { Box, Typography } from "@mui/material";
import useUploadTimer from "../../hooks/useUploadTimer";

export default function DescriptiveRemainingTimer({ uploadDuration, onExpire }) {
  const { formattedTime, isExpired } = useUploadTimer(uploadDuration);

  const hasCalledExpire = useRef(false);

  useEffect(() => {
    if (isExpired && !hasCalledExpire.current) {
      hasCalledExpire.current = true; 
      onExpire?.();
    }
  }, [isExpired, onExpire]);

  // const borderColor = isExpired ? "#c62828" : "#5B8CDD";
  const timerColor = isExpired ? "#c62828" : "#1e1e1e";

  return (
    <Box
      sx={{
        position: "relative",
        border: `1.5px solid ${isExpired ? "#c62828" : "#333"}`,
        borderRadius: "8px",
        px: { xs: 1.5, sm: 2.5 },
        py: { xs: 0.75, sm: 1 },
        minWidth: { xs: "90px", sm: "120px" },
        textAlign: "center",
        backgroundColor: "white",
        transition: "border-color 0.3s",
        flexShrink: 0,
      }}
    >
      {/* Floating label on top border */}
      <Typography
        sx={{
          position: "absolute",
          top: "-9px",
          left: "50%",
          transform: "translateX(-50%)",
          fontSize: "10px",
          backgroundColor: "white",
          px: 0.75,
          whiteSpace: "nowrap",
          color: timerColor,
          lineHeight: 1,
          transition: "color 0.3s",
        }}
      >
        Remaining Time
      </Typography>

      <Typography
        sx={{
          fontSize: { xs: "14px", sm: "16px" },
          fontWeight: "bold",
          color: timerColor,
          transition: "color 0.3s",
          fontVariantNumeric: "tabular-nums",
          letterSpacing: "1px",
        }}
      >
        {formattedTime}
      </Typography>
    </Box>
  );
}